import { Injectable } from '@angular/core';
import { BaseService } from "./base.service";
import { Http } from '@angular/http';
import * as Enum from '../utils/enums';
import { Observable } from "rxjs";
import { RequestBuilder } from '../classes/request-builder';

@Injectable()
export class EsecutoreService extends BaseService {


  /**
   * Costruttore
   * @param http Servizio di richieste HTTP 
   */
  constructor(http: Http) {
    super(http);
  }

  /**
   * get all attivita
   * @param reqBuilder data
   */
  getAttivitaByEsecutore(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('esecutore/fetchAllAttivita', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * get all pagamenti
   * @param reqBuilder data
   */
  getPagamentiByEsecutore(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('esecutore/fetchAllPagamenti', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }



  /**
   * get all Esecutori
   * @param reqBuilder 
   */
  fetchEsecutori(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('esecutore/fetch', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * get all Esecutori con stato antimafia verificato
   * @param reqBuilder 
   * @returns 
   */
  fetchEsecutoriStatoAntimafia(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('esecutore/fetchByVerificaAntimafia', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * Save Esecutore
   * @param reqBuilder 
   */
  save(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('esecutore/save', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * update Esecutore
   * @param reqBuilder 
   */
  update(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('esecutore/update', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * delete Esecutore
   * @param reqBuilder 
   */
  deleteEsecutore(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('esecutore/delete', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  getRichiesteApprovate(requestBuilder: RequestBuilder) {
    return this.doPost('richiesta/FetchRichiesteApprovate', requestBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

}
